import { useId } from 'react';

// `view-transition-name` is a custom-ident and cannot contain the ':' that
// React's useId emits, so strip it.
export const useViewTransitionId = (prefix?: string) => {
  const id = useId().replace(/:/g, '');

  return prefix ? `${prefix}-${id}` : id;
};
